import {
  CourseShortDataT,
  CourseLessonsDataT,
} from "@interfaces/internal-study/courses";

import Fetcher from "@http/fetcher";
import { ResCallback } from "@interfaces/common";

class InternalStudyCoursesService {
  static async getAll(cb: ResCallback<CourseShortDataT[]>) {
    try {
      const res = await Fetcher.get<CourseShortDataT[]>(
        "/educational-center/internal-training/courses"
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async getById(id: string, cb: ResCallback<CourseShortDataT>) {
    try {
      const res = await Fetcher.get<CourseShortDataT>(
        `/educational-center/internal-training/courses/${id}`
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      return cb(err);
    }
  }

  static async sync(
    data: {
      type?: "course" | "lesson";
      process?: "all" | "only";
      id?: string;
      course?: string;
    },
    cb: ResCallback<CourseShortDataT>
  ) {
    try {
      const res = await Fetcher.post<CourseShortDataT>(
        "/educational-center/internal-training/courses/sync",
        data
      );

      if (res.status === 201) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async update(
    id: number,
    data: FormData | CourseShortDataT,
    cb: ResCallback<CourseShortDataT>
  ) {
    try {
      const res = await Fetcher.patch<CourseShortDataT>(
        `/educational-center/internal-training/courses/${id}`,
        data
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async delete(id: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.delete<string>(
        `/educational-center/internal-training/courses/${id}`
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async updateLesson(
    id: number,
    data: FormData | CourseLessonsDataT,
    cb: ResCallback<CourseLessonsDataT>
  ) {
    try {
      const res = await Fetcher.patch<CourseLessonsDataT>(
        `/educational-center/internal-training/courses/lessons/${id}`,
        data
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async deleteLesson(id: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.delete<string>(
        `/educational-center/internal-training/courses/lessons/${id}`
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }
}

export default InternalStudyCoursesService;
